export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  // [Prov] Conversas que a automação (menu de identificação/IA) está
  // conduzindo agora — o Prov grava custom_attributes.prov_ia='atendendo'
  // enquanto o robô segura a conversa e 'repassada' no handoff. Elas saem de
  // "Não atribuídas" (que passa a ser fila de gente) e moram nesta aba,
  // visível a qualquer atendente, com as mesmas permissões de "Não
  // atribuídas".
  ia: {
    count: 'iaCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  // [Prov] A aba "Todas" deixa de ser liberada a qualquer atendente. No
  // upstream ela passa para todo mundo (...ROLES inclui 'agent'), dando a
  // qualquer um a visão de TODAS as conversas da conta.
  //
  // Quem passa aqui é 'conversation_view_all', uma permissão que o Prov
  // concede a partir do grupo de administradores DELE (ver
  // AccountUser#permissions). Ela dá visibilidade e mais nada — de propósito:
  // promover a pessoa a administrador do Chatwoot resolveria a aba, mas
  // entregaria junto configurações da conta, caixas de entrada, integrações e
  // a tela de versão. 'administrator' segue na lista porque quem de fato
  // administra a conta continua vendo tudo.
  all: {
    count: 'allCount',
    permissions: ['administrator', 'conversation_view_all'],
  },
};
